export default __webpack_public_path__ + "static/media/mr_mrs_smith_background_m1.21e7782e.jpg";